import '../scss/main.scss';

/**
 * Entry point. Block-specific behaviors are dynamically imported so only the
 * code needed by a given page is fetched.
 */
const bootstrap = (): void => {
	if (document.querySelector('.rsna-header__nav')) {
		void import('./blocks/header.js');
	}
	if (document.querySelector('[data-rsna-header-shell]')) {
		void import('./blocks/header-shell.js');
	}
	if (document.querySelector('.rsna-hero')) {
		void import('./blocks/hero.js');
	}
	if (document.querySelector('[data-rsna-form]')) {
		void import('./blocks/form.js');
	}
	if (document.querySelector('[data-rsna-innovations]')) {
		void import('./blocks/carousel.js');
	}
	if (document.querySelector('[data-rsna-schedule]')) {
		void import('./blocks/schedule.js');
	}
	if (document.querySelector('[data-rsna-presenter-carousel]')) {
		void import('./blocks/presenters.js');
	}
	if (document.querySelector('[data-rsna-photo-strip]')) {
		void import('./blocks/photo-strip.js');
	}
	if (document.querySelector('[data-rsna-innovation-cards]')) {
		void import('./blocks/innovation-cards.js');
	}
	if (document.querySelector('[data-rsna-testimonials]')) {
		void import('./blocks/testimonials.js');
	}
	if (document.querySelector('[data-rsna-demo-form]')) {
		void import('./blocks/request-demo.js');
	}
	// Gated on the anchored cards themselves rather than on a block, because an
	// authored anchor is what there is to do here — and because the card that has
	// one need not be on a page whose other JS is already loading.
	if (document.querySelector('[data-rsna-anchor]')) {
		void import('./blocks/card-links.js');
	}
	// Intro / feature-list / sponsor-strip currently have no interactive
	// behavior — CSS-only. Add imports here when they gain JS.
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
	bootstrap();
}
